var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission-wrapper flex-all-center"},[_vm._v(" 中金支付功能仍处于封闭测试中，仅授权企业可以使用。请耐心等待功能发布。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }